import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import React from 'react'
import { useWatch } from 'react-hook-form'
import { SettingsBox } from 'src/Elements/Data'
import { useUser } from 'src/Hooks/useUser'
import { useInstallationForm } from 'src/Libs/flow/installation/hooks'
import { TabButtonGroup } from 'src/Libs/inputs/react-hook-form'
import { useInstallationAccessRightsContext } from 'src/Libs/installation-rights-management/provider/InstallationAccessRightsContext'

export const TrackersBehaviour: React.FC<{ storageIndex: number }> = ({ storageIndex }) => {
  const { t } = useCustomTranslation()
  const { hasInstallationWritingRights: canEdit } = useInstallationAccessRightsContext()
  const { userData } = useUser()

  const { control } = useInstallationForm()
  const trackersBehaviour = useWatch({
    control,
    name: `storageSystem.storageSpecificSettings.${storageIndex}.chargingConfiguration.trackersBehaviour`,
  })

  const isUserLevelUser = userData?.level === 'USER'

  return (
    <SettingsBox
      title={t(`installation.storageEditor.chargingBehaviour`)}
      description={t(`installation.flowEditor.${trackersBehaviour === 'single tracker' ? 'singleTrackerDescription' : 'duoTrackerDescription'}`)}
      suffix={
        <TabButtonGroup
          name={`storageSystem.storageSpecificSettings.${storageIndex}.chargingConfiguration.trackersBehaviour`}
          options={[
            {
              label: t('installation.flowEditor.singleTracker'),
              value: 'single tracker',
            },
            {
              label: t('installation.flowEditor.duoTracker'),
              value: 'duo tracker',
            },
          ]}
          disabled={!canEdit || isUserLevelUser}
        />
      }
    />
  )
}
